import LZString from './lz-string.min'
import { isWeiXin } from "./open-download-app";
import { Dialog } from "vant"
import { toast } from '@/utils/util';
export const PAY_STATUS = {
    SUCC: 1,
    FAIL: 0,
    UNKNOWN: -1
}

const pageUrl = location.href
const PAY_BACK_PARAM = `payBack=1`
const LAST_PAY_INFO = '__last_pay_info'
export function showPayConfirm({ onPayComplete }) {
    if (pageUrl.indexOf(PAY_BACK_PARAM) !== -1) {
        try {
            const info = JSON.parse(localStorage.getItem(LAST_PAY_INFO))
            _showPayConfirm({
                payType: info.payType,
                payParams: info.payParams,
                onPayComplete,
            })
        } catch (e) {
            console.log('处理跳转回来逻辑出错', e)
        }
    }

}
function _showPayConfirm({ payType, onPayComplete, payParams }) {
    const callback = onPayComplete || (() => { });
    // 支付跳转回来
    Dialog.confirm({
        title: `支付完成确认`,
        message: `请确认${payType === 'wxpayH5' ? '微信支付' : "支付宝支付"}已完成`,
        confirmButtonText: '已完成支付',
        cancelButtonText: '遇到问题，重新支付',
        className: 'pay-result-dialog',
    }).then(() => {
        callback({ type: payType, payStatus: PAY_STATUS.UNKNOWN, payParams })
    }).catch(() => {
        // 去除payBack参数，刷新当前页面，重新走一遍流程
        const url = pageUrl.replace(PAY_BACK_PARAM, '')
        if (url === location.href) {
            location.reload();
        } else {
            location.replace(url);
        }
    })
}
// 唤起支付
export function callPay(options) {
    const {
        payType,
        payParams,
        // 支付完成回调，h5支付时用户 已完成支付按钮 时触发，给调用方手动查询支付结果使用
        onPayComplete
    } = options
    const callback = onPayComplete || (() => { });
    if (payType === 'wxpayH5' && isWeiXin()) {
        // 微信里必须用微信公众号支付(jsapi)
        // if (!payParams.appId && !payParams.appid) {
        //     toast(`参数缺失: ${JSON.stringify(payParams)}`)
        //     callback({ type: 'JSAPI', payStatus: PAY_STATUS.FAIL, payParams })
        //     return
        // }
        callWxJSAPIPay({
            appId: payParams.appid || payParams.appId,
            timeStamp: payParams.time_stamp || payParams.timeStamp,
            nonceStr: payParams.nonce_str || payParams.nonceStr,
            signType: 'RSA',
            paySign: payParams.sign,
            package: `prepay_id=${(payParams.prepay_id || payParams.prepayId)}`,
            ...payParams,
        }).then(() => {
            // if (redirectUrl) {
            //     location.href = redirectUrl
            // }
            callback({ type: 'JSAPI', payStatus: PAY_STATUS.SUCC, payParams })
        }).catch(e => {
            // 支付失败
            console.log('JSAPI支付失败', e)
            callback({ type: 'JSAPI', payStatus: PAY_STATUS.FAIL, payParams })
        })
    } else {
        // https://pay.weixin.qq.com/docs/merchant/products/h5-payment/development.html#_3-2-api%E6%8E%A5%E5%85%A5-%E5%90%AB%E7%A4%BA%E4%BE%8B%E4%BB%A3%E7%A0%81
        const url = location.href
        callH5Pay({
            ...options,
            // h5支付完成后，跳转回原来的页面，原来的页面调用showPayConfirm，发现是支付回来的链接，则显示确认弹窗
            // 目前这个实现只有微信支付是正确的。支付宝无效，得在创建订单时，走后端接口时将return_url传入 https://opendocs.alipay.com/open/203/105285?pathHash=ada1de5b#%E9%87%8D%E8%A6%81%E5%85%A5%E5%8F%82%E8%AF%B4%E6%98%8E
            redirectUrl: `${url}${url.indexOf('?') === -1 ? '?' : /&$/.test(url) ? '' : '&'}${PAY_BACK_PARAM}`
        }) // 微信中使用支付宝，此函数会显示提示用默认浏览器打开页面，todo明确callH5Pay职责，新写支付宝微信提示页

        if (isWeiXin()) return;

        localStorage.setItem(LAST_PAY_INFO, JSON.stringify(options))

        // 用户点击返回键，可能回到原来的页面，在原来的页面上直接展示弹窗
        _showPayConfirm({
            payType,
            payParams,
            onPayComplete
        })
    }
}


// 调用微信公众号支付(jsapi)
function callWxJSAPIPay(params) {
    return new Promise((resolve, reject) => {
        const requestPay = () => {
            console.log('getBrandWCPayRequest:', params)
            window.WeixinJSBridge.invoke(
                "getBrandWCPayRequest",
                {
                    ...params,
                },
                (res) => {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    // res.err_msg将在用户支付成功后返回 ok，但并不保证它绝对可靠。
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        resolve(true)
                    } else {
                        reject()
                    }
                }
            );
        }
        if (typeof window.WeixinJSBridge === "undefined") {
            document.addEventListener(
                "WeixinJSBridgeReady",
                requestPay,
                false
            );
        } else {
            requestPay()
        }
    })
}

// 获取微信jsCode
export function getWxJsCode() {
    const matchCode = /code=([^&]+)/.exec(location.href)
    const jsCode = matchCode?.[1]
    console.log('jscode----', jsCode);
    if (!jsCode) {
        // 调用授权登录接口
        location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxea4ae255733cb575&redirect_uri=${encodeURIComponent(location.href)}&response_type=code&scope=snsapi_base#wechat_redirect`)
        return ""
    } else {
        return jsCode
    }
}
// 唤起h5支付
function callH5Pay({
    payType,
    payParams,
    redirectUrl,
    ...otherParams
}) {
    const payInfoCompress = LZString.compressToBase64(JSON.stringify({
        ...payParams,
    }))

    window.globalRouter.push({
        path: '/middlePageOfPay',
        query: {
            ...otherParams,
            info: payInfoCompress,
            // from: 'sameType',
            payType,
            redirectUrl: redirectUrl ? encodeURIComponent(redirectUrl) : ''
        },
    });
}